export default function CReturnValues() {
  return <h2>C Return Values</h2>;
}
